import React, { useState, } from 'react';
import { Row, Col, Button, Space } from 'antd';
import { TableOutlined, } from '@ant-design/icons';
import { Modal } from '../../../UI/Modal/Modal.component';
import { Status } from '../Status/Status.component';
import { getPath } from '../../../../services/StationService';

const statusStyle = {
    margin: '6px 1.5px 0 1.5px',
    padding: 0,
};

export const EthernetPorts = ({data, modal, ...props}) => {

    const CLIENT_SETTINGS = {
        service: '172.17.1.21',
        vpn: 'remotedevices.avalan.com',
        vpn2: '172.17.1.20',
    };

    const DEFAULT_MAX_PORTS = 5;
    const IP_MODAL_SIZE = 20;
    const ips = {};
    
    const [displayModal, setDisplayModal] = useState(false);
    const { status, ipInfo: addresses, usbKeyID, parityBits, } = data;

    let portsList; 

    if(addresses){
        addresses?.forEach((value, index) => {
            Object.keys(value).forEach((key) => {
                Object.assign(ips,{[key]: value[key].join(", ")});
            })
        });
    }

    const handleInterfaceButton = () => {

        let params = { serialNum: data.serialNum, port: -2 }
        let trailURL = "/graphs";

        getPath(params).then(function( response ) {
            let url = "https://" + CLIENT_SETTINGS.vpn + ":" + response[0] + trailURL;
            let window1 = window.open('', '_blank');
            setTimeout(function () {
				window1.location = url + "";
			}, 1000);
        })
    }

    const displayEthernetPorts = () => {

        const statusContainerStyle = {
            textAlign: 'center', 
            width: modal ? 130 : undefined,
            wordBreak: 'break-all', 
        }

        const detectedIpStyle = {
            wordBreak: 'normal', 
            whiteSpace: 'normal', 
            overflowWrap: 'break-word',
        }
        
        let ethernetPorts = [];

        // if(status){
            if(parityBits){
                portsList = parityBits?.split('').map(x => parseInt(x));
                if (usbKeyID !== null && usbKeyID !== "" && parityBits.length < 8 && data.deviceType !== 'CSEVC') {
                    portsList.reverse();
                    ethernetPorts = portsList.map((port, i) => 
                        <Space key={`port-${i+1}`} direction='vertical' style={statusContainerStyle}>
                            <Status 
                                key={`port-${i+1}`}
                                size={modal ? IP_MODAL_SIZE : undefined} 
                                visible={modal} 
                                tooltipText={!modal && (i === 0 ? 'UPLINK' : (ips[Math.abs(i - parityBits.length)] || 'IP not detected'))} 
                                tooltipPlacement='top'
                                status={port === 1} 
                                style={statusStyle}
                            />
                            { modal &&
                                <code style={detectedIpStyle}>
                                    {i === 0 ? 'UPLINK' : (ips[Math.abs(i - parityBits.length)] || 'IP not detected')}
                                </code>
                            }
                        </Space>
                    );
                    
                } else {
                    const getUplinkPort = () => {
                        if (parityBits.length === DEFAULT_MAX_PORTS){
                            return 3; 
                        } else if (parityBits.length === 8){
                            return 8; 
                        } else if (parityBits.length === 16){
                            return 1; 
                        }
                    }

                    ethernetPorts = portsList.map((port, i) => 
                        <Space key={`port-${i+1}`} direction='vertical' style={statusContainerStyle}>
                            <Status 
                                key={`port-${i+1}`}
                                size={modal ? IP_MODAL_SIZE : null}
                                visible={modal} 
                                tooltipText={!modal && (i === (getUplinkPort() - 1) ? 'UPLINK' : (ips[i+1] || 'IP not detected'))} 
                                tooltipPlacement='top'
                                status={port === 1}
                                style={statusStyle}
                            />
                            { modal &&
                                <code style={detectedIpStyle}>
                                    {i === (getUplinkPort() - 1) ? 'UPLINK' : (ips[i+1] || 'IP not detected')}
                                </code>
                            }
                        </Space>
                    );
                }
            // }
        } else {
            // Device is offline or doesn't have parity bits data
            let max_ports = parityBits ? parityBits?.length : (data.deviceType === 'CSEVC' ? 8 : DEFAULT_MAX_PORTS);
            for (let i=0; i < max_ports; i++){
                ethernetPorts.push(
                    <Status 
                        key={`port-${i}`}
                        size={modal ? IP_MODAL_SIZE : undefined} 
                        status={'default'} 
                        style={statusStyle}
                    />
                );
            }
        }
        
        // Switches with 16 ports are displayed in 2 rows of 8, with odd numbers on bottom and even numbers on top. 
        if (parityBits?.length === 16){
            const evenIndex = ethernetPorts.filter((_, index) => (index+1) % 2 === 0);
            const oddIndex = ethernetPorts.filter((_, index) => (index+1) % 2 !== 0);
            return (
                !displayModal ? 
                    <Row>
                        <Col span={24}>
                            {evenIndex}
                        </Col>
                        <Col span={24}>
                            {oddIndex}
                        </Col>
                    </Row>
                : 
                <>
                    <Row style={{width: '100%'}}>
                        <Col span={24} style={{width: '100%', borderBottom: status && '2px solid rgba(0,0,0,0.1)'}} >
                            <Row justify='space-around' style={{ margin: '15px auto' }}>
                                {evenIndex}
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row justify='space-around' style={{margin: '15px auto'}}>
                                {oddIndex}
                            </Row>
                        </Col>
                    </Row>
                </>
            )
        } else {
            return ethernetPorts;
        }
    };

    return(
        <>
            { !modal ? 
                <Row key={data.deviceID} className="ethernet-ports" wrap={false} {...props}>
                    {displayEthernetPorts()}
                </Row>
                : 
                <>
                    <Button type='primary' icon={<TableOutlined/>} onClick={() => setDisplayModal(true)}>Detected IPs</Button>
                    { displayModal && 
                        <Modal 
                            title='Detected IPs'
                            visible={displayModal}
                            setVisible={setDisplayModal}
                            extra={<Button onClick={() => handleInterfaceButton()}>Interface History</Button>}
                            width={parityBits?.length >= 8 ? 1200 : 850}
                            >
                            <Row justify='space-around' style={{margin: '30px auto',}}>
                                {displayEthernetPorts()}
                            </Row>
                        </Modal>
                    }
                </>
            }
        </>
    );
}

EthernetPorts.defaultProps = {
    status: 'default',
    modal: false,
    data: {},
}